import moment from "moment";
import { find, map, propEq } from "ramda";
import { DropdownOption } from "src/createEntityModal/types";
import { MetadataInputOption } from "src/metadata/types";
import { Currency } from "../../metadata/types";
import { AccountPresenter } from "../model/presenter/types";

export const accountValueKey = (account: AccountPresenter, index: number) =>
  `${account.id}_${index}`;

export const getPeriodYearsFromDates = (periods: string[]): string => {
  if (periods.length > 1) {
    return `${moment(new Date(periods[0])).format("YYYY")}, ${moment(
      new Date(periods[1])
    ).format("YYYY")}`;
  } else {
    return moment(new Date(periods[0])).format("YYYY");
  }
};

export const formatCurrenciesIntoDropdownOptions = (
  currencies: Currency[]
): DropdownOption[] => {
  return map((currency: Currency) => {
    return {
      value: currency.code,
      label: `${currency.name} ${currency.code} - ${currency.symbol}`
    } as DropdownOption;
  }, currencies);
};

export const findCurrencyDropdownOptionFromName = (
  currencyName: string,
  currencyDropdownOptions: MetadataInputOption[]
): MetadataInputOption => {
  return find(propEq("value", currencyName))(currencyDropdownOptions);
};



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/helpers.ts